import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconThumbsUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M19.587.057a3.003 3.003 0 0 1 2.357 3.532L21.8 4.3a14.898 14.898 0 0 1-1.8 4.7h9a3 3 0 0 1 1.381 5.663 3 3 0 0 1-1.312 5.28 3 3 0 0 1 .431 1.557 2.996 2.996 0 0 1-2.069 2.85 3 3 0 0 1-2.931 3.65h-6.094a6.013 6.013 0 0 1-3.331-1.006l-2.406-1.607A6 6 0 0 1 10 20.395v-6.95c0-1.825.831-3.544 2.25-4.688l.463-.368a8.979 8.979 0 0 0 3.2-5.263l.143-.712A3.003 3.003 0 0 1 19.587.057ZM2 10.001h4c1.106 0 2 .894 2 2v14c0 1.106-.894 2-2 2H2c-1.106 0-2-.894-2-2v-14c0-1.106.894-2 2-2Z"
	})
});
export default SvgIconThumbsUp;
